/**
 * Generated runtime TestId mirror for frontend/src/components/shared/PageLayout.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const PageLayoutTestIds = {
  btnBack: "btn-back",
  loadingSkeleton: "loading-skeleton",
  pageLayoutActions: "page-layout-actions",
  pageLayoutCard: "page-layout-card",
  pageLayoutContent: "page-layout-content",
  pageLayoutCount: "page-layout-count",
  pageLayoutDescription: "page-layout-description",
  pageLayoutFilters: "page-layout-filters",
  pageLayoutHeader: "page-layout-header",
  pageLayoutIcon: "page-layout-icon",
  pageLayoutStats: "page-layout-stats",
  pageLayoutTabBar: "page-layout-tab-bar",
  pageLayoutTabs: "page-layout-tabs",
  pageLayoutTitle: "page-layout-title",
  pageLayoutWizardNav: "page-layout-wizard-nav",
  tabPanelContent: "tab-panel-content",
  tabPanelCount: "tab-panel-count",
  tabPanelDescription: "tab-panel-description",
  tabPanelFilters: "tab-panel-filters",
  tabPanelHeader: "tab-panel-header",
  tabPanelPagination: "tab-panel-pagination",
  tabPanelTitle: "tab-panel-title",
  tab: (tab_key: string) => `tab-${tab_key}`,
  tabPrefix: () => "tab-" as TestIdPrefix
} as const;
